
























































import {
  computed,
  defineComponent,
  ref,
  watch,
  getCurrentInstance
} from "@vue/composition-api";
import OccPanel from "@/components/Atoms/OccPanel/index.vue";
import { sendGaEvent } from "@/helpers/ga-helper";

export default defineComponent({
  name: "OccAccordion",
  components: {
    OccPanel
  },
  props: {
    type: {
      type: String,
      default: ""
    },
    open: {
      type: Boolean,
      default: false
    },
    underline: {
      type: Boolean,
      default: false
    },
    toggle: {
      type: Function,
      default: null
    },
    headingColor: {
      type: String,
      default: ""
    },
    headingPadding: {
      type: [String, Number],
      default: ""
    },
    rounded: {
      type: [Boolean, String],
      default: false
    },
    iconColor: {
      type: String,
      default: "font-light"
    },
    activeIconColor: {
      type: String,
      default: "primary"
    },
    gaEventCategory: {
      type: String,
      default: ""
    }
  },
  setup(props) {
    const dataOpen = ref<boolean>(props.open);
    const blockName = computed(() => {
      return props.type ? `occ-accordion-${props.type}` : "occ-accordion";
    });
    watch(dataOpen, newValue => {
      dataOpen.value = newValue;
    });

    const instance = getCurrentInstance();
    const toggleDataOpen = () => {
      if (instance) {
        sendGaEvent(instance.proxy, {
          gaEventCategory: `${props.gaEventCategory}_アコーディオン_${
            !dataOpen.value ? "開く" : "閉じる"
          }`
        });
      }
      props.toggle ? props.toggle : (dataOpen.value = !dataOpen.value);
    };
    const beforeEnter = (element: { style: { height: string } }) => {
      element.style.height = "0";
    };
    const enter = (element: {
      style: { height: string };
      scrollHeight: any;
    }) => {
      element.style.height = `${element.scrollHeight}px`;
    };
    const afterEnter = (element: {
      style: { height: string; overflow: string };
    }) => {
      element.style.height = "";
      element.style.overflow = "";
    };
    const afterLeave = (element: {
      style: { height: string; overflow: string };
    }) => {
      element.style.height = "";
      element.style.overflow = "";
    };
    const beforeLeave = (element: {
      style: { height: string };
      scrollHeight: any;
    }) => {
      element.style.height = `${element.scrollHeight}px`;
    };
    const leave = (element: { style: { height: string } }) => {
      element.style.height = "0";
    };

    return {
      dataOpen,
      blockName,
      toggleDataOpen,
      beforeEnter,
      enter,
      afterEnter,
      beforeLeave,
      leave,
      afterLeave
    };
  }
});
